import TextCreate from 'core/display/simple/Text'
import { signal } from 'services/SignalsService'

export default class FreeBetLeft extends TextCreate{
  constructor(data) {
    super(data)

    this.freebetModel = game.models.FreebetsModel.get()
    this.visible = false
    this.text.visible = false

    this.update()
    signal.on('STATE:IN:SPIN', this.spin.bind(this))
    signal.on('FREEBET:Enabled', this.visibility.bind(this))
    signal.on('STATE:IN:FB-ADD', this.visibility.bind(this, true))
    signal.on('STATE:OUT:FB-ADD', this.visibility.bind(this, false))
    signal.on('STATE:IN:FREE-BET', this.visibility.bind(this, true))
    signal.on('STATE:OUT:FREE-BET', this.visibility.bind(this, false))
  }

  spin() {
    if(this.freebetModel.rest === 0){
      return
    }
    this.update(this.freebetModel.rest - 1 || '')
  }

  update() {
    super.update(this.freebetModel.rest || '')
  }

  visibility(enable) {
    this.text.visible = enable
    this.update()
  }
}
